import { render } from "./Game2.vue?vue&type=template&id=4ceb6479&scoped=true&ts=true"
import script from "./Game2.vue?vue&type=script&lang=ts"
export * from "./Game2.vue?vue&type=script&lang=ts"

import "./Game2.vue?vue&type=style&index=0&id=4ceb6479&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ceb6479"]])

export default __exports__